<template>
  <div class="chart-stat-card" :class="cardClasses">
    <h3>{{ config.title }}</h3>
    <p>Chart card coming soon...</p>
  </div>
</template>

<script>
export default {
  name: "ChartStatCard",
  props: {
    config: { type: Object, required: true },
    data: { type: Object, default: () => ({}) }
  },
  computed: {
    cardClasses() {
      return ["bg-white", "rounded-xl", "shadow-sm", "border", "p-6"];
    }
  }
};
</script>
